<!--
################################################################################################
######    Vista SVC91010  :  Formulario Pago TPV (CECA) - Petición Autorización (1/3)     ######
################################################################################################
-->

<template>
<div>
  
  <!-- 
  <TNC10000></TNC10000>

  <div class="igs-color2 igs-center igs-bold">
    <br/>
    TPV Virtual CECA
  </div>
  -->

  <div>

    <br/>
    <div class="igs-h4 igs-color1 igs-center">Importe a Pagar</div>
    <br/>

    <div class="row">
      <div class="col-2">&nbsp;</div>
      <div class="col-4 igs-center"><img :src="f99ImageName('ih1-importe-azul')" height="64"></div>
      <div class="col-4 igs-h4 igs-color1 igs-center igs-v-center">{{$store.state.strTPVMensajeImporte}}</div>
      <div class="col-2">&nbsp;</div>
    </div>

    <div><hr/></div>

    <div class="row">
      <div class="col-12 igs-h4 igs-center">Medio de Pago<br/></div>
    </div>

    <div class="row">
      <div class="col-12 igs-h4 igs-center">
        <img :src="f99ImageName('ih1-tarjeta-bancaria-azul')"                 height="64" v-if="!lbOperacionBizum && !lbOperacionAutenticacion">
        <img :src="f99ImageName('ih1-tarjeta-bancaria-autenticacion-azul')"   height="64" v-if="lbOperacionAutenticacion">
        <img :src="f99ImageName('ih1-bizum-azul')"                            height="64" v-if="lbOperacionBizum">
      </div>
    </div>

    <div class="row">
      <div class="col-12 igs-h4 igs-center" v-if="!lbOperacionBizum && !lbOperacionAutenticacion">Tarjeta Bancaria</div>
      <div class="col-12 igs-h4 igs-center" v-if="lbOperacionAutenticacion">Pre-Autorización Bancaria</div>
      <div class="col-12 igs-h4 igs-center" v-if="lbOperacionBizum">Bizum</div>
    </div>

    <div><hr/></div>

    <div class="row" v-if="lbMostrarGuardarTarjeta">
      <div class="col-9 igs-l3 igs-center">
        <label class="form-check-label" for="defaultCheck1">Deseo guardar los datos de la tarjeta para próximas compras</label>
      </div>
      <div class="col-1">&nbsp;</div>
      <div class="col-1 igs-v-center igs-center">
          <input class="form-check-input" style="width:20px; height:20px;" type="checkbox" id="Ds_GuardarTarjeta" ref="rfGuardarTarjeta" @click="lp60GuardarTarjeta()">   
      </div>
      <div class="col-1">&nbsp;</div>
    </div>
    <div v-if="lbMostrarGuardarTarjeta"><hr/></div>

    <!-- Leyenda para "Se va a utilizar la siguiente tarjeta ..." -->
    <div class="row" v-if="lbMostrarTarjetaGuardada">
      <div class="igs-l3 igs-color1 igs-center col-12">Se utilizará la siguiente tarjeta para el pago :</div>
      <div class="igs-l3 igs-color7 igs-center col-12">{{$store.state.strTPVLeyendaDatosTarjeta}}</div>
    </div>
    <div v-if="lbMostrarTarjetaGuardada"><hr/></div>

    <div class="row">
      <div class="col-12 igs-l2 igs-center">Para confirmar el pago pulse el botón PAGAR. <br/></div>
    </div>

    <!--
    <div class="igs-h4 igs-color2 igs-center">{{$store.state.strTPVMensajeTitulo}}</div>
    <div class="igs-h3 igs-color1 igs-center">{{$store.state.strTPVMensajeSubtitulo}}</div>
    -->

    <br/>

    <form ref="TPVCeca" id="TPVCeca" :action="ltURLTPV" method="POST" enctype="application/x-www-form-urlencoded">
        <input type="hidden" name="MerchantID"         :value="ltMerchantID" />
        <input type="hidden" name="AcquirerBIN"        :value="ltAcquirerBIN" />
        <input type="hidden" name="TerminalID"         :value="ltTerminalID" />

        <input type="hidden" name="URL_OK"             :value="ltURLOk" />
        <input type="hidden" name="URL_NOK"            :value="ltURLNoOk" />

        <input type="hidden" name="Referencia"         :value="$store.state.strTPVMensajeSubtitulo" v-if="$store.state.strTPVMerchantPayMethods == '2' || $store.state.strTPVMerchantPayMethods == '9'" />

        <input type="hidden" name="Firma"              :value="ltFirma" />
        <input type="hidden" name="Cifrado"             value="SHA2" />
        <input type="hidden" name="Num_operacion"      :value="ltNumeroOperacion" />
        <input type="hidden" name="Descripcion"        :value="ltDescripcion" />
        <input type="hidden" name="Importe"            :value="ltImporte" />

        <input type="hidden" name="TipoMoneda"         :value="ltTipoMoneda" />
        <input type="hidden" name="Exponente"          :value="ltExponente" />
        <input type="hidden" name="Pago_soportado"      value="SSL" />
        <input type="hidden" name="Idioma"              value="1" />
        <input type="hidden" name="Idusuario"          :value="$store.state.strCliente"      v-if="ltGuardarTarjeta == '1' || ltSavedTPVMerchantIdentifier != ''" />
        <input type="hidden" name="Token"              :value="ltSavedTPVMerchantIdentifier" v-if="ltSavedTPVMerchantIdentifier != ''" />

        <!--
        <input type="hidden" name="datos_acs_20”"      :value="ltDatosACS20" />
        <input type="hidden" name="firma_acs_20”"      :value="ltFirmaACS20" />
        -->

        <input type="submit" value="Pagar" class="btn btn-lg btn-outline-dark" ref="TPVCeca_Enviar">
    </form>      
        
  </div>

</div>
</template>

<script>
import igs_mixin from '@/igs-mixins/igs_mixin'
const  axios = require("axios")


//import TNC10000  from '@/igs-navegacion/TNC10000'
//import BNC10000  from '@/igs-navegacion/BNC10000'

export default {
  mixins: [ igs_mixin ],
  //components : { TNC10000, BNC10000 },

  //=======================================================================
  //------------------------ Variables Locales  ---------------------------
  //=======================================================================
  data() {
    return {
        lSWModoProduccion               : false,

        ltMerchantID                    : '',
        ltAcquirerBIN                   : '',
        ltTerminalID                    : '',
        ltURLOk                         : '',
        ltURLNoOk                       : '',
        ltFirma                         : '',
        ltNumeroOperacion               : '',
        ltDescripcion                   : '',
        ltImporte                       : '',
        ltTipoMoneda                    : '978',
        ltExponente                     : '2',
        ltCifrado                       : 'SHA2',
        ltDatosACS20                    : '',
        ltFirmaACS20                    : '',

        ltURLTPV                        : '',

        ltGuardarTarjeta                : '0',
        ltSavedMerchantID               : '',
        ltSavedTPVMerchantIdentifier    : '',

        lbOperacionBizum                : false,
        lbOperacionAutenticacion        : false,
        lbMostrarGuardarTarjeta         : false,
        lbMostrarTarjetaGuardada        : false  
    }
  },

  //=======================================================================
  //------------------------ Variables Calculadas  ---------------------------
  //=======================================================================
  computed : {

  },


  //=======================================================================
  //------------------------ Métodos Locales  ---------------------------
  //=======================================================================
  methods: {

    //--------------------------------------------------------------------------------
    //-- Animación Inicial al Mostrar la Página de Login
    //--------------------------------------------------------------------------------
    // eslint-disable-next-line no-unused-vars
    onPageLoaded (args) {

      //-- Ocultar Indicadores de Actividad
      this.$store.commit('p10StrRecibiendoDatos', false);

    },


    //--------------------------------------------------------------------------------
    //-- Iniciar una Nueva Transacción (TPV Redsys)
    //--------------------------------------------------------------------------------
    lp50IniciarTransaccion() {

        //console.log('-- Inicio Petición Autorización --');

        //-- Extraer valores a utilizar en este Método
        var indiceTPV             = this.$store.state.strT001M030_Indice;  // Valores : 1, 2, ..., n

        //----- TEMPORAL (Pruebas) ----
        // indiceTPV = 2;
        //-----------------------------

        if (indiceTPV > 0) { indiceTPV = indiceTPV - 1; }                  // Aplicar : 0, 1, ..., n-1

        var secretTPV             = this.f75DesofuscarTexto(this.$store.state.strT001M030[indiceTPV].secretComercio);
        //console.log('SecretTPV ........ : '+secretTPV);
        //var nombreComercioTPV     = this.$store.state.strT001M030[indiceTPV].nombreComercio;

        //-- Cargar Variables Locales
        this.ltMerchantID         = this.$store.state.strT001M030[indiceTPV].codigoComercio;
        this.ltAcquirerBIN        = this.$store.state.strT001M030[indiceTPV].codigoEntidad;
        this.ltTerminalID         = this.$store.state.strT001M030[indiceTPV].terminalComercio;
        //console.log('this.ltMerchantID  : '+this.ltMerchantID);
        //console.log('this.ltAcquirerBIN : '+this.ltAcquirerBIN);
        //console.log('this.ltTerminalID  : '+this.ltTerminalID);

        //-- Valores Específicos del Pedido
        this.ltNumeroOperacion    = this.$store.state.strReferenciaPedido;      //-- Número de Referencia (Nro. de Pedido iHoreca)
        this.ltImporte            = this.$store.state.strImportePedido;         //-- Importe


        //-- (a) URLs del Panel : Desarrollo ó Producción
        var URLPanel  = 'http://' + window.location.hostname + ':8080';
        if (window.location.hostname == "panel.ihoreca.es") { URLPanel  = "https://panel.ihoreca.es"; }

        //-- (b) URLs TPV Virtual : Prueba ó Producción
        this.ltURLTPV   = 'https://tpv.ceca.es/tpvweb/tpv/compra.action';
        if (this.$store.state.strT001M030[indiceTPV].modoProduccion) {  this.ltURLTPV = 'https://pgw.ceca.es/tpvweb/tpv/compra.action'; }

        //-- (1)=Solicitud PreAutorización para Cargo Posterior 
        if (this.$store.state.strTPVMerchantPayMethods == '1') {           
          this.ltURLTPV = 'https://tpv.ceca.es/tpvweb/autorizacion/solicitud.action';
          if (this.$store.state.strT001M030[indiceTPV].modoProduccion) {  this.ltURLTPV = 'https://pgw.ceca.es/tpvweb/autorizacion/solicitud.action'; }
        }

        //-- (2)=Confirmación PreAutorización (Cargo Firme)
        if (this.$store.state.strTPVMerchantPayMethods == '2') {           
          this.ltURLTPV = 'https://tpv.ceca.es/tpvweb/autorizacion/cobrar.action';
          if (this.$store.state.strT001M030[indiceTPV].modoProduccion) {  this.ltURLTPV = 'https://pgw.ceca.es/tpvweb/autorizacion/cobrar.action'; }
        }

        //-- (9)=Cancelación PreAutorización
        if (this.$store.state.strTPVMerchantPayMethods == '9') {           
          this.ltURLTPV = 'https://tpv.ceca.es/tpvweb/anulaciones/anular.action';
          if (this.$store.state.strT001M030[indiceTPV].modoProduccion) {  this.ltURLTPV = 'https://pgw.ceca.es/tpvweb/anulaciones/anular.action'; }
        }

        //console.log(' Servidor = '+this.ltURLTPV);

        //-- Aplicar el parámetro adecuado cuando se AUTORIZA CONSERVAR la TARJETA para (Uso Futuro) (Tokenizacion)
        /*
        if (this.ltGuardarTarjeta == '1') {
          this.$store.commit('p10StrTPVMerchantIdentifier', 'REQUIRED');
        } else {
          this.$store.commit('p10StrTPVMerchantIdentifier', this.ltSavedTPVMerchantIdentifier);
        }
        */

        this.ltURLOk     = URLPanel + '/95010/' +   this.$store.state.strDistribuidor        + '/' + 
                                                    this.$store.state.strUsuario             + '/' + 
                                                    this.$store.state.strIDSesion            + '/' + 
                                                    this.$store.state.strCliente             + '/' + 
                                                    this.$store.state.strNifClienteOfuscado  + '/' + 
                                                    this.$store.state.strReferenciaPedido    + '/' + 
                                                    this.$store.state.strImportePedido       + '/' +
                                                    '0'                                      + '/';

         this.ltURLNoOk  = URLPanel + '/95010/' +   this.$store.state.strDistribuidor        + '/' + 
                                                    this.$store.state.strUsuario             + '/' + 
                                                    this.$store.state.strIDSesion            + '/' + 
                                                    this.$store.state.strCliente             + '/' + 
                                                    this.$store.state.strNifClienteOfuscado  + '/' +
                                                    this.$store.state.strReferenciaPedido    + '/' + 
                                                    this.$store.state.strImportePedido       + '/'  +
                                                    '1'                                      + '/';

        //-- Descripcion X(1000) - Uso Interno (Tienda)
        this.ltDescripcion      = this.$store.state.strDistribuidor + this.$store.state.strUsuario + 
                                  'C' + this.$store.state.strCliente + 'R' + this.$store.state.strReferenciaPedido + 
                                  'M' + this.ltGuardarTarjeta + 'I' + this.$store.state.strImportePedido + '|' +
                                  's='+this.$store.state.strIDSesion+
                                  '&u='+this.$store.state.strUsuario+
                                  '&d='+this.$store.state.strDistribuidor+
                                  '&c='+this.$store.state.strCliente+
                                  '&t=230&m=911'+
                                  '&n='+this.$store.state.strNifClienteOfuscado+
                                  '&x='+this.$store.state.strReferenciaPedido;
                                  
        //-- Datos Operación Comercio Seguro
        //this.ltDatosACS20       = '';
        //this.ltFirmaACS20       = '';

        //.............................
        //-- Cálculo de Firma
        //.............................
        var mensajeCECA =   secretTPV + 
                            this.ltMerchantID       + 
                            this.ltAcquirerBIN      + 
                            this.ltTerminalID       +
                            this.ltNumeroOperacion  +
                            this.ltImporte          +
                            this.ltTipoMoneda       +
                            this.ltExponente        +
                            this.ltCifrado          +
                            this.ltURLOk            +
                            this.ltURLNoOk;

        //....................................
        //-- (2)-Confirmación PreAutorización
        //-- (9)-Cancelar     PreAutorizacion
        //....................................
        if ((this.$store.state.strTPVMerchantPayMethods == '2') || (this.$store.state.strTPVMerchantPayMethods == '9')) {                                       
          mensajeCECA =   secretTPV + 
                            this.ltMerchantID       + 
                            this.ltAcquirerBIN      + 
                            this.ltTerminalID       +
                            this.ltNumeroOperacion  +
                            this.ltImporte          +
                            this.ltTipoMoneda       +
                            this.ltExponente        +
                            this.$store.state.strTPVMensajeSubtitulo +
                            this.ltCifrado;
          console.log('mensajeCECA : '+mensajeCECA);                            
        }

        this.ltFirma = this.f70SHA256(mensajeCECA,  '1');

        //console.log('-- mensajeCECA --');
        //console.log(mensajeCECA);

        //console.log('-- ltFirma --');
        //console.log(this.ltFirma);

        //-- DEBUG
        //console.log('-- Fin Paso .1. --');

        //-- La CONFIRMACIÓN ó CANCELACIÓN de una "Pre-Autorización" y/o "Pre-Autenticación" no requiere PAUSA para que el usuario confirme la operación
        if ((this.$store.state.strTPVMerchantPayMethods == '2') || (this.$store.state.strTPVMerchantPayMethods == '9')) {
          //this.$refs.TPVCeca_Enviar.click();
          setTimeout(() => {  this.$refs.TPVCeca_Enviar.click(); }, 100);
        }


    },

    //------------------------------------------------------
    //-- Conmutar valor de la Check "Guardar Tarjeta"
    //------------------------------------------------------
    lp60GuardarTarjeta() {

      //-- Conmutar y Conservar el Valor de la "CheckBox"
      if (this.ltGuardarTarjeta == '0') {
        this.ltGuardarTarjeta                 = '1';
        this.$refs.rfGuardarTarjeta.checked   = true;
      } else {
        this.ltGuardarTarjeta                 = '0';
        this.$refs.rfGuardarTarjeta.checked   = false;
      }

      //-- Recalcular Transacción
      this.lp50IniciarTransaccion();

      //console.log(' lp60GuardarTarjeta : '+this.ltGuardarTarjeta);
    },


    //------------------------------------------------------
    //-- Reclamar Lista de TPV Virtuales disponibles
    //------------------------------------------------------
    lp98t001m030() {
      
      var URL = global.lnkServerAppURL + "&s="+this.$store.state.strIDSesion+"&d="+this.$store.state.strDistribuidor+"&u="+this.$store.state.strUsuario+"&t=001&m=030";
      //console.log(URL);

      //-- Mostrar el/los indicadores de actividad oportunos
      this.$store.commit('p10StrRecibiendoDatos', true);
        
      //-- Solicitud de Datos al Servidor 
      axios.get(URL, {responseEncoding: 'utf-8'})
      .then(respuesta => {
      
            //console.log('Respuesta : ');
            //console.log(respuesta.data);

            //-- Desactivar los Indicadores de Actividad
            this.$store.commit('p10StrRecibiendoDatos', false);

            //-- Extraer la respuesta recibida
            var datos = respuesta.data;

            //-- Determinar si el contenido es el correcto
            if (datos.t001m030) {
              //-- Debug
              //console.log('-- Lista de TPVs OK --');
              //console.log('** Array **');
              //console.dir(datos.t001m030);
              //console.log('** Índice **');
              //console.dir(datos.t001m030_indice);
              //console.log('----------------------');
              
              //-- Actualizar Información relacionada con los TPVs
              this.$store.commit('p10StrT001M030',        datos.t001m030);
              this.$store.commit('p10StrT001M030_Indice', datos.t001m030_indice);

              //var i = this.$store.state.strT001M030_Indice;
              //console.log(' (A) Índice = '+i);


              //-- Solicitar Autorización para el PAGO
              this.lp50IniciarTransaccion();
            } else {
                this.p99AnuncioIH1('2','7','ERROR', 'Error TPV91010<br/>'+respuesta.data.msg,-1);
            }
                
        })
        .catch(error => {
          //-- Desactivar los Indicadores de Actividad
          this.$store.commit('p10StrRecibiendoDatos', false);

          //-- Mostrar el Mensaje de Error oportuno
          this.p99AnuncioIH1('2','7','ERROR', error.message,-1);
        });

    }


  },

  //=======================================================================
  //------------ Métodos a aplicar una vez CARGADA la Página  -------------
  //=======================================================================
  mounted() {
    //console.log('SVC91010 mounted');

    //-- Conservar el Valor de (strTPVMerchantIdentifier)
    this.ltSavedTPVMerchantIdentifier = this.$store.state.strTPVMerchantIdentifier;

    //-- Mostrar Leyenda "Guardar Tarjeta"
    if ((this.ltSavedTPVMerchantIdentifier == '') && (this.$store.state.strTPVMerchantPayMethods != 'z')) { this.lbMostrarGuardarTarjeta    = true; }

    //-- Mostrar Leyenda "Se va a utilizar la siguiente tarjeta ..."
    if ((this.ltSavedTPVMerchantIdentifier != '') && (this.$store.state.strTPVMerchantPayMethods != 'z')) { this.lbMostrarTarjetaGuardada   = true; }

    //-- Determinar si se trata de una Operación de Autenticación (Pre-Autorización para Cargo Posterior)
    if (this.$store.state.strTPVMerchantPayMethods == '1') { this.lbOperacionAutenticacion  = true; }

    //-- Determinar si se trata de una Operación BIZUM (o no)
    if (this.$store.state.strTPVMerchantPayMethods == 'z') { this.lbOperacionBizum          = true; }


    //this.lp50IniciarTransaccion();
    this.lp98t001m030();

  }
}


/*
================================================================================================================================================
    DATOS GENÉRICOS DE PRUEBA
================================================================================================================================================

        Para la realizacion de pruebas, cada comercio debe utilizar sus valores facilitados por su entidad para lo siguientes parámetros:

            (1) Número de Comercio              (MerchantID)
            (2) Numero de Entidad Bancaria      (AcquirerBIN)
            (3) Terminal                        (TerminalID)
            (4) Clave secreta                   (Clave de Encriptación)

    ..............................................................................................................................................

         Tarjeta: 5540500001000004 - Caducidad: 12/AAAA - CVV2: 989
         Tarjeta: 5020470001370055 - Caducidad: 12/AAAA - CVV2: 989
         Tarjeta: 5020080001000006 - Caducidad: 12/AAAA - CVV2: 989
         Tarjeta: 4507670001000009 - Caducidad: 12/AAAA - CVV2: 989         

         En modo de compra segura (CES), en la que se requiera autenticación del comprador, el código de identificación personal (CIP) es: 
            123456

*/

</script>

<style type="scope">
</style>

